module.exports = __webpack_public_path__ + "app-static/img/my.616e4ad1.png";